type AttendancesType = 'attending' | 'declined';
type AttendancesTypeUppperCase = Uppercase<AttendancesType>;

const Attendances: Record<AttendancesTypeUppperCase, AttendancesType> = {
  ATTENDING: 'attending',
  DECLINED: 'declined',
};

export default Attendances;
